<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="13" view-id="10013" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="13" :data="data">
					<!--状态-->
					<template #apply_status>
						<c-state dict="flowOrderStateDic" :value="data.apply_status"></c-state>
					</template>

					<!--归还凭证图片-->
					<template #voucher_image_url>
                        <c-file-list :value="data.voucher_image_url" size="mini"></c-file-list>
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_asset_return',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/assets/return/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>